/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Slider from '../../Slider/Slider';

const useStyles = makeStyles((theme) => ({
   RecipientWhatsInsideTab: {
      backgroundColor: '#C8E3C6',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      padding: theme.spacing(2),
      overflowX: 'hidden',
      fontFamily: theme.palette.thankyoucards.typography
   },
   digIntoDetails: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '30px',
      lineHeight: '40px',
      textAlign: 'center',
      letterSpacing: '0.01em',
      color: theme.palette.common.black,
      paddingTop: '4rem',
      paddingLeft: '4rem',
      paddingRight: '4rem',
      margin: '0px',
      '@media screen and (max-width: 393px)': {
         paddingTop: '3rem',
         paddingLeft: '2.5rem',
         paddingRight: '2.5rem',
     },
   },
   whatsInsideText: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '30px',
      lineHeight: '40px',
      textAlign: 'center',
      letterSpacing: '0.01em',
      color: theme.palette.common.black,
      paddingTop: '3rem',
      paddingLeft: '4rem',
      paddingRight: '4rem',
      margin: '0px',
      '@media screen and (max-width: 393px)': {
         paddingTop: '2rem',
         paddingLeft: '2.5rem',
         paddingRight: '2.5rem',
     },
   },
   productNameText: {
      fontStyle: 'normal',
      fontSize: '24px',
      lineHeight: '32px',
      textAlign: 'center',
      letterSpacing: '0.01em',
      margin: '0px',
      color: theme.palette.common.black
   }
 }));

const RecipientWhatsInsideTab = ({ id, reference }) => {
   const classes = useStyles();

  return (
    <div id={`section-${id}`} ref={reference} className={classes.RecipientWhatsInsideTab}>
      <Box>
         <p className={classes.digIntoDetails}>
            Dig Into the Details of Your Gift
         </p>
      </Box>
      <Box>
         <p className={classes.whatsInsideText}>
            What&apos;s Inside
         </p>
         <p className={classes.productNameText}>
            Fields of Europe® Winter Bliss
         </p>
      </Box>
      <Slider />
    </div>
  )
}

export default RecipientWhatsInsideTab